<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="modal"
      centered
      size="md"
      class="alert-modal"
      hide-header-close
      footer-class="pt-0 border-0"
    >
      <template #modal-header> <div class="modal-title">
        เปลี่ยนเวลา
      </div>  </template>
      <div class="text-center">
        <div class="d-flex justify-content-center my-3 text-black text-center w-100">
          <div class="text-center w-50">
            <InputTextMask
              :placeholder="placeholder"
              :value="form.due_date"
              className="mb-2"
             mask="##/##/#### ##:##"
              masked
              @onDataChange="changeTime"
            
            />
            <p>กรุณาระบุเป็น ปี พ.ศ.
              <P class="f-12 text-gray">dd/mm/yyyy hh:mm</P>
            </p>
          </div>
          
        </div>
      
        <div v-if="$v.form.due_date && $v.form.due_date.$error">
       
          <span class="text-error" v-if="$v.form.due_date.minValue == false">
            เวลาที่ปรับต้องไม่น้อยกว่าวันที่<br />   {{ $moment().subtract(1, 'days').set({ hour: 23, minute: 59, second: 0 }).add(543, "years").format("DD MMMM YYYY HH:mm") }}
          </span>
        
        </div>
        <div class="f-14 text-danger mt-2" v-if="form.due_date && !$moment(form.due_date, 'DD/MM/YYYY HH:mm').isValid() && isValidate">
          <p> วันที่และเวลาไม่ถูกต้อง</p>
        </div>
      </div>
      <template #modal-footer="{ hide }">
        <div class="d-flex justify-content-between w-100 my-0">
          <b-button
            variant="primary-color"
            class="btn-modal btn-hover w-50 mr-1"
            @click="save"
          
          >
            ยืนยัน
          </b-button>
          <b-button
            variant="close"
            class="btn-modal btn-hover w-50 ml-1"
            @click="hide('forget')"
    
          >
            ยกเลิก
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import InputTextMask from "@/components/inputs/InputTextMask";
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import { TheMask } from "vue-the-mask";
import { mapGetters } from "vuex";

export default {
  components: {
    InputTextMask,
    TheMask,
  },
  props: {
    branchId: {
      required: true,
      type: [String, Number],
    },
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      form: { due_date: "" },
      today: null,
      allowDay: null,
      allowTimeChange: {
        result: 0,
        allowDay: 0,
        allowMonth:0
      },
      isFirstEdit: true,
      placeholder: '',
      isValidate: false,
      mask: '',
    };
  },
  validations() {
  return {
    form: {
      due_date: {
        required,
    minValue(value) {
        if (this.$moment(value, "DD/MM/YYYY HH:mm").isValid()) {
  
        let m = this.$moment(value, "DD/MM/YYYY HH:mm").add(-543, "years");
        let dateTime = m.unix();

        let allowDay = this.$moment()
        .subtract(1, 'days')
        .set({ hour: 23, minute: 59, second: 0 })
        .unix();

        return dateTime >= allowDay;
  }
  return true;
},

      },
    },
  };
},
created() {
  this.today = this.$moment().add(543, "years")
  this.allowDay = this.$moment().subtract(1, "days").set({ hour: 23, minute: 59, second: 0 }).format("DD MMMM YYYY HH:mm");
  this.form.due_date = this.today;
},

  methods: {
 
    async show() {
      this.$v.form.$reset();
      this.isValidate = false
    

    
      this.form.due_date = "DD/MM/YYYY HH:MM";
      this.placeholder = "DD/MM/YYYY HH:MM";
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    changeTime(val) {

        this.form.due_date = val;
      
    },
    
    async save() {
      // if(this.form.changeTime === "DD/MM/YYYY HH:MM"){
      //   this.form.changeTime = this.today
      // }
 
 
        this.$v.form.$touch();
        this.isValidate = true
        if (this.$v.form.$error || !this.$moment(this.form.due_date, "DD/MM/YYYY HH:mm").isValid()) return;
      
        this.isLoading = true;
        let dateTime = await this.$moment(this.form.due_date, "DD/MM/YYYY HH:mm").add(-543, "years").format(
          "YYYY-MM-DDTHH:mm:ss"
        );
     
      this.$emit('success',dateTime )
      this.showModal = false
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  color: #fff;
  width: 100%;
  background-color: var(--primary-color);


}
::v-deep .modal-body {
  padding: 1rem 1rem;
}
.btn-primary .modal-body {
  margin: auto;
  text-align: center;
}
::v-deep .nav-tabs li:nth-child(2) {
  border-left: 1px solid white;
  border-right: 1px solid white;
}

@media (max-width: 768px) {
  ::v-deep .div-input {
    width: 100%;
  }
  ::v-deep .modal-dialog {
    margin: 0px;
    max-width: 100vw !important;
    .modal-content {
      width: 100vw;
      height: 100vh;
      .modal-body{
        overflow-y: auto;
      }
    }
  }
}
</style>
